"use client";

import { useEffect } from "react";
import OneSignal from "react-onesignal";

type OneSignalScriptProps = {
  appId: string;
  safariWebId?: string;
  enviroment?: string;
};

export const OneSignalScript = ({ appId, safariWebId, enviroment }: OneSignalScriptProps) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      OneSignal.init({
        appId: appId,
        safari_web_id: safariWebId,
        notifyButton: {
          enable: true,
          prenotify: true,
          showCredit: false,
          text: {
            "tip.state.unsubscribed": "Subscribe to notifications",
            "tip.state.subscribed": "You're subscribed to notifications",
            "tip.state.blocked": "You've blocked notifications",
            "message.prenotify": "Click to subscribe to notifications",
            "message.action.subscribed": "Thanks for subscribing!",
            "message.action.resubscribed": "You're subscribed to notifications",
            "message.action.unsubscribed": "You won't receive notifications again",
            "message.action.subscribing": "Subscribing...",
            "dialog.main.title": "Manage Site Notifications",
            "dialog.main.button.subscribe": "Subscribe",
            "dialog.main.button.unsubscribe": "Unsubscribe",
            "dialog.blocked.title": "Unblock Notifications",
            "dialog.blocked.message": "Follow these instructions to allow notifications:",
          },
        },
        allowLocalhostAsSecureOrigin: enviroment === "development",
      });
    }
  }, []);

  return null;
};
